<div class="container" [ngStyle]="{'width': data.type ==='cycle' ? '500px' : '250px' }">
    <h2>Add New {{data.title}}</h2>
    <mat-form-field *ngIf="data.type!=='cycle'">
        <input type="text" matInput placeholder="{{data.title}} name" [(ngModel)]="data.name">
    </mat-form-field>
    <mat-form-field *ngIf="data.type==='gateway' || data.type==='sensor'">
        <input type="text" matInput placeholder="Hardware ID" [(ngModel)]="data.hardwareId">
    </mat-form-field>

    <!-- Zone -->
    <mat-form-field *ngIf="data.type==='zone'">
        <mat-label>Pick gateway</mat-label>
        <mat-select [(ngModel)]="data.gateway">
            <mat-option *ngFor="let item of items['gateway']" [value]="item._id">
            {{item.name}} ({{item.hardwareId}})
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="data.type==='zone'">
        <mat-label>Zone role</mat-label>
        <mat-select [(ngModel)]="data.zoneRole">
            <mat-option *ngFor="let item of zoneRole" [value]="item">
            {{item}}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="data.type==='zone'">
        <input type="number" matInput placeholder="Zone size" [(ngModel)]="data.zoneSize">
    </mat-form-field>


    <mat-form-field *ngIf="data.type==='sensor'">
        <mat-label>Sensor kind</mat-label>
        <mat-select [(ngModel)]="data.kind">
            <mat-option *ngFor="let sk of items['sensorKinds']" [value]="sk">
                {{ sk }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <!-- Company -->
    <mat-form-field *ngIf="data.type==='company'">
        <input type="text" matInput placeholder="Contact name" [(ngModel)]="data.contactName">
    </mat-form-field>
    <mat-form-field *ngIf="data.type==='company'">
        <input type="text" matInput placeholder="Address" [(ngModel)]="data.address">
    </mat-form-field>
    <mat-form-field *ngIf="data.type==='company'">
        <input type="text" matInput placeholder="Email" [(ngModel)]="data.email">
    </mat-form-field>
    <mat-form-field *ngIf="data.type==='company'">
        <input type="text" matInput placeholder="Phone" [(ngModel)]="data.phone">
    </mat-form-field>
   
    <!-- Cycle -->
    <div class="cols">
        <div class="col">
            <div class="row">
                <mat-form-field *ngIf="data.type ==='cycle'">
                    <mat-label>Current State</mat-label>
                    <mat-select [(ngModel)]="data.currentState" (selectionChange)="fillterAlowd('zone')">
                        <mat-option *ngFor="let state of allowdStates" [value]="state" >
                        {{state}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <!-- <mat-form-field *ngIf="data.type==='cycle' && data.currentState.state ==='Custom'">
                    <input type="text" matInput placeholder="Custom State" [(ngModel)]="customState">
                </mat-form-field> -->
            </div>
            <div class="row">
                <mat-form-field *ngIf="data.type==='cycle' && data.zone">
                    <mat-label>Pick zone</mat-label>
                    <mat-select [(ngModel)]="data.zone._id" (selectionChange)="getParing($event.value)">
                        <mat-option *ngFor="let zone of allowdZones" [value]="zone._id" >
                            {{ zone.name }} ({{ zone.gatewayName }}) - {{zone.role}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field *ngIf="data.type==='sensor' || (data.type==='cycle' && !data.zone)">
                    <mat-label>Pick zone</mat-label>
                    <mat-select [(ngModel)]="data.zoneId" (selectionChange)="getParing($event.value)">
                        <mat-option *ngFor="let zone of allowdZones" [value]="zone._id">
                            {{ zone.name }} ({{ zone.gatewayName }}) - {{zone.role}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field *ngIf="data.type==='cycle'">
                    <input type="text" matInput placeholder="Strain name" [(ngModel)]="data.name">
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field *ngIf="data.type==='cycle' &&  data.currentState !== 'Drying'">
                    <input type="number" matInput placeholder="Plants Quantity" [(ngModel)]="data.plantsQuantity">
                </mat-form-field>
                <mat-form-field *ngIf="data.type==='cycle' &&  data.currentState === 'Drying'">
                    <input type="number" matInput placeholder="Wet Weight" [(ngModel)]="data.wetWeight">
                </mat-form-field>
            </div>       
            <!-- <div class="row"> 
                <mat-form-field *ngIf="data.type==='cycle'">
                    <input type="number" matInput placeholder="Percentages of the zone" [(ngModel)]="data.percentagesOfZone">
                </mat-form-field>
            </div> -->
            <!-- <div class="row">
                <mat-form-field *ngIf="data.type==='cycle'">
                    <mat-label>Pick duration type</mat-label>
                    <mat-select [(ngModel)]="data.durationType">
                        <mat-option value="days">Days</mat-option>
                        <mat-option value="weeks">Weeks</mat-option>
                    </mat-select>
                </mat-form-field>
            </div> -->
            <div class="cycleTimes">
                <div class="row">
                    <mat-form-field *ngIf="data.type==='cycle' && this.data.cycleTimes">
                        <input type="number" matInput placeholder="Mother time" [(ngModel)]="data.cycleTimes.motherTime">
                    </mat-form-field>
                   
                </div>
                <div class="row">
                    <mat-form-field  class="smallField" *ngIf="data.type==='cycle' && this.data.cycleTimes">
                        <input type="number" matInput placeholder="Rooting time" [(ngModel)]="data.cycleTimes.rootingTime">
                    </mat-form-field>
                    <mat-form-field class="smallField" *ngIf="data.type==='cycle' && this.data.cycleTimes">
                        <input type="number" matInput placeholder="Veg time" [(ngModel)]="data.cycleTimes.vegTime">
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-form-field class="smallField" *ngIf="data.type==='cycle' && this.data.cycleTimes">
                        <input type="number" matInput placeholder="Flowering time" [(ngModel)]="data.cycleTimes.floweringTime">
                    </mat-form-field>
                    <mat-form-field class="smallField" *ngIf="data.type==='cycle' && this.data.cycleTimes">
                        <input type="number" matInput placeholder="Flush time" [(ngModel)]="data.cycleTimes.flushingTime">
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-form-field class="smallField" *ngIf="data.type==='cycle' && this.data.cycleTimes">
                        <input type="number" matInput placeholder="Drying time" [(ngModel)]="data.cycleTimes.dryingTime">
                    </mat-form-field>
                    <mat-form-field class="smallField" *ngIf="data.type==='cycle' && this.data.cycleTimes">
                        <input type="number" matInput placeholder="Curing time" [(ngModel)]="data.cycleTimes.curingTime">
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-form-field class="smallField" *ngIf="data.type==='cycle' && this.data.cycleTimes">
                        <input type="number" matInput placeholder="Pack time" [(ngModel)]="data.cycleTimes.packTime">
                    </mat-form-field>
                    <mat-form-field class="smallField" *ngIf="data.type==='cycle' && this.data.cycleTimes">
                        <input type="number" matInput placeholder="Safe time" [(ngModel)]="data.cycleTimes.safeTime">
                    </mat-form-field>
                </div>
            </div>
        </div>
        
        <div class="col">
            <section *ngIf="data.type==='cycle' && paring.subtasks.length">
                <!-- <mat-label>Paring Sensors and Appliances</mat-label> -->
                <span class="example-list-section">
                    <mat-checkbox [(ngModel)]="data.paring"
                    [checked]="selectAll"
                    [color]="paring.color"
                    [indeterminate]="someComplete()"
                    (change)="setAll($event.checked)">
                        {{paring.name}}
                    </mat-checkbox>
                </span>
                <span class="example-list-section">
                    <ul>
                      <li *ngFor="let subtask of paring.subtasks">
                        <mat-checkbox [(ngModel)]="subtask.completed"
                                      [color]="subtask.color"
                                      (ngModelChange)="updateAllComplete()">
                          {{subtask.name}} ({{subtask.kind}})
                        </mat-checkbox>
                      </li>
                    </ul>
                  </span>
            </section>
        </div>
    </div>
   
   
    
    <!-- User -->
    <mat-form-field *ngIf="data.type==='user'">
        <input type="text" matInput placeholder="Email" [(ngModel)]="data.email">
    </mat-form-field>
    <mat-form-field *ngIf="data.type==='user'">
        <input type="text" matInput placeholder="Password" [(ngModel)]="data.password">
    </mat-form-field>
    <mat-form-field *ngIf="data.type==='user'">
        <input type="text" matInput placeholder="Phone" [(ngModel)]="data.phone">
    </mat-form-field>
    <mat-form-field *ngIf="data.type==='user' && data.company!=undefined">
        <mat-label>Role</mat-label>
        <mat-select [(ngModel)]="data.role">
            <mat-option value="r">Read Only</mat-option>
            <mat-option value="rw">Read / Write</mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="data.type==='user' && data.company===undefined">
        <mat-label>Role</mat-label>
        <mat-select [(ngModel)]="data.role">
            <mat-option value="sa">Super Admin</mat-option>
        </mat-select>
    </mat-form-field>
    <!-- <mat-form-field *ngIf="data.type==='user'"> -->
    <section class="example-section" *ngIf="data.type==='user'">
        <mat-checkbox class="example-margin" color="primary" [(ngModel)]="data.notificationsEnabled">Enabled notifications</mat-checkbox>
    </section>

    <section class="example-section" *ngIf="data.type==='user' && data.notificationsEnabled">
        <mat-checkbox class="notificationOptions" color="primary" [(ngModel)]="data.notificationsEnabledEmail">Email</mat-checkbox>
        <mat-checkbox class="notificationOptions" color="primary" [(ngModel)]="data.notificationsEnabledSms">SMS</mat-checkbox>
        <mat-checkbox class="notificationOptions" color="primary" [(ngModel)]="data.notificationsEnabledPush">Push</mat-checkbox>
    </section>
        
        <!-- <mat-checkbox type="text" matInput placeholder="Enabled notifications" [(ngModel)]="data.notificationsEnabled"> -->
    <!-- </mat-form-field> -->
    <!-- <mat-form-field *ngIf="data.type==='cycle'">
        <mat-label>Pick zone</mat-label>
        <mat-select [(ngModel)]="data.zoneId">
            <mat-option *ngFor="let zone of items['zone']" [value]="zone._id">
                {{ zone.name }} ({{ zone.gatewayName }})
            </mat-option>
        </mat-select>
    </mat-form-field> -->
    <mat-dialog-actions align="end">
        <button mat-button [mat-dialog-close]="undefined">Cancel</button>
        <button mat-flat-button color="primary" (click)="onConfirm()">Save</button>
    </mat-dialog-actions>
    <div class="loading-wrapper" *ngIf="isLoading">
        <mat-spinner diameter="30"></mat-spinner>
    </div>
</div>